export default __webpack_public_path__ + "static/media/Flyer-06.66469c02.jpg";